class FaqTabs extends HTMLElement {
    constructor() {
        super();
        this.buttons = this.querySelectorAll('[data-item]');
        this.tabs = this.querySelectorAll('[data-tab]');
        this.openTab();
    }

    openTab() {        
        this.buttons.forEach((button)=> {
            button.addEventListener('click', ()=> {
                this.tabs.forEach(element => {
                    element.classList.remove('active');
                });

                this.buttons.forEach(element => {
                    element.classList.remove('active');
                });

                button.classList.add('active');

                const item = button.dataset.item;
                const activeTab = this.querySelector(`[data-tab="${item}"]`);
                if(activeTab) {
                    activeTab.classList.add('active');
                }
            })
        }) 
    }
}



customElements.define('faq-tabs', FaqTabs)